
import Websocket from '@/utils/websocket';

const EVENT_KEYS = [
  'global:sync', //监听同步数据
  'global:re-sync', //监听补偿数据
  'global:projectUser', //监听当前用户被项目移除
  'global:connect', //连接后
  'global:version-ack', // 监听版本信息反馈
  'global:projectQueryAll', //角色权限变更
  'global:incremental-sync-done', //同步结束
  'global:disconnect' //链接失败
];

export default class Socket{

  constructor(eventMap) {
    this.eventMap = eventMap || {};
    this.socket = new Websocket();
    this.listenerSocket();
  }

  connectSocket({ token, language, wsUrl }){
    this.socket.connect(wsUrl, {
      namespace: '/indexdb',
      query: {
        token,
        language
      }
    });
  }

  listenerSocket() {
    EVENT_KEYS.forEach(
      key => {
        this.socket.on(key, e => {
          if (this.eventMap[key] && typeof this.eventMap[key] === 'function'){
            this.eventMap[key](e);
          }
        });
      }
    );
  }
}
